"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface CompareProduct {
  id: string;
  name: string;
  slug: string;
  price: number;
  coverImageUrl?: string;
  categoryName?: string;
}

interface CompareStore {
  items: CompareProduct[];
  add: (product: CompareProduct) => void;
  remove: (id: string) => void;
  toggle: (product: CompareProduct) => void;
  clear: () => void;
  has: (id: string) => boolean;
}

const MAX = 4;

export const useCompareStore = create<CompareStore>()(
  persist(
    (set, get) => ({
      items: [],
      add: (product) =>
        set((s) => {
          if (s.items.length >= MAX || s.items.some((p) => p.id === product.id)) return s;
          return { items: [...s.items, product] };
        }),
      remove: (id) => set((s) => ({ items: s.items.filter((p) => p.id !== id) })),
      toggle: (product) => {
        const { has, add, remove } = get();
        if (has(product.id)) {
          remove(product.id);
        } else {
          add(product);
        }
      },
      clear: () => set({ items: [] }),
      has: (id) => get().items.some((p) => p.id === id),
    }),
    { name: "compare-list" }
  )
);
